import CreateDeductionType from "../settings/deductionTypes/components/CreateDeductionType";
import CreateEncashmentType from "../settings/encashmentTypes/components/CreateEncashmentType";
import CreateAbsentPolicy from "../absentPolicy/components/CreateAbsentPolicy";
import UpdateAbsentPolicy from "../absentPolicy/components/UpdateAbsentPolicy";
import CreateMissingPolicy from "../missingPolicy/components/CreateMissingPolicy";
import UpdateMissingPolicy from "../missingPolicy/components/UpdateMissingPolicy";
import CreateLateArrivalPolicy from "../lateArrivalPolicy/components/CreateLateArrivalPolicy";
import UpdateLateArrivalPolicy from "../lateArrivalPolicy/components/UpdateLateArrivalPolicy";
import CreateEarlyLeftPolicy from "../earlyLeftPolicy/components/CreateEarlyLeftPolicy";
import UpdateEarlyLeftPolicy from "../earlyLeftPolicy/components/UpdateEarlyLeftPolicy";
import CreateShortDurationPolicy from "../shortDurationPolicy/components/CreateShortDurationPolicy";
import UpdateShortDurationPolicy from "../shortDurationPolicy/components/UpdateShortDurationPolicy";
import CreateRelaxationPolicy from "../relaxationPolicy/components/CreateRelaxationPolicy";
import UpdateRelaxationPolicy from "../relaxationPolicy/components/UpdateRelaxationPolicy";
import CreateLeavePolicy from "../leavePolicy/components/CreateLeavePolicy";
import UpdateLeavePolicy from "../leavePolicy/components/UpdateLeavePolicy";
import CreateOvertimePolicy from "../overtimePolicy/components/CreateOvertimePolicy";
import UpdateOvertimePolicy from "../overtimePolicy/components/UpdateOvertimePolicy";
import CreateCplPolicy from "../cplPolicy/components/CreateCplPolicy";
import UpdateCplPolicy from "../cplPolicy/components/UpdateCplPolicy";
import { getAllDataReq as getAbsentPolicyDataReq } from "../absentPolicy/requests";
import { getAllDataReq as getMissingPolicyDataReq } from "../missingPolicy/requests";
import { getAllDataReq as getLateArrivalPolicyDataReq } from "../lateArrivalPolicy/requests";
import { getAllDataReq as getEarlyLeftPolicyDataReq } from "../earlyLeftPolicy/requests";
import { getAllDataReq as getShortDurationPolicyDataReq } from "../shortDurationPolicy/requests";
import { getAllDataReq as getRelaxationPolicyDataReq } from "../relaxationPolicy/requests";
import { getAllDataReq as getLeavePolicyDataReq } from "../leavePolicy/requests";
import { getAllDataReq as getOvertimePolicyDataReq } from "../overtimePolicy/requests";
import { getAllDataReq as getCplPolicyDataReq } from "../cplPolicy/requests";

export const attendancePlannerSetupTypes = [
  {
    key: "deductionType",
    label: "Deduction Type",
    createComponent: CreateDeductionType,
  },
  {
    key: "encashmentType",
    label: "Encashment Type",
    createComponent: CreateEncashmentType,
  },
];

export const attendancePlannerPolicyDependencies = [
  {
    key: "absentPolicy",
    label: "Absent",
    field: "absent_policy_id",
    relatedListKey: "absent_policies",
    responseKey: "absent_policys",
    previewKey: "absent_policy",
    createComponent: CreateAbsentPolicy,
    updateComponent: UpdateAbsentPolicy,
    requestFn: getAbsentPolicyDataReq,
  },
  {
    key: "missingPolicy",
    label: "Missing",
    field: "missing_policy_id",
    relatedListKey: "missing_policies",
    responseKey: "missing_policys",
    previewKey: "missing_policy",
    createComponent: CreateMissingPolicy,
    updateComponent: UpdateMissingPolicy,
    requestFn: getMissingPolicyDataReq,
  },
  {
    key: "lateArrivalPolicy",
    label: "Late Arrival",
    field: "late_arrival_policy_id",
    relatedListKey: "late_arrival_policies",
    responseKey: "late_arrival_policys",
    previewKey: "late_arrival_policy",
    createComponent: CreateLateArrivalPolicy,
    updateComponent: UpdateLateArrivalPolicy,
    requestFn: getLateArrivalPolicyDataReq,
  },
  {
    key: "earlyLeftPolicy",
    label: "Early Left",
    field: "early_left_policy_id",
    relatedListKey: "early_left_policies",
    responseKey: "early_left_policys",
    previewKey: "early_left_policy",
    createComponent: CreateEarlyLeftPolicy,
    updateComponent: UpdateEarlyLeftPolicy,
    requestFn: getEarlyLeftPolicyDataReq,
  },
  {
    key: "shortDurationPolicy",
    label: "Short Duration",
    field: "short_duration_policy_id",
    relatedListKey: "short_duration_policies",
    responseKey: "short_duration_policys",
    previewKey: "short_duration_policy",
    createComponent: CreateShortDurationPolicy,
    updateComponent: UpdateShortDurationPolicy,
    requestFn: getShortDurationPolicyDataReq,
  },
  {
    key: "relaxationPolicy",
    label: "Relaxation",
    field: "relaxation_policy_id",
    relatedListKey: "relaxation_policies",
    responseKey: "relaxation_policys",
    previewKey: "relaxation_policy",
    createComponent: CreateRelaxationPolicy,
    updateComponent: UpdateRelaxationPolicy,
    requestFn: getRelaxationPolicyDataReq,
  },
  {
    key: "leavePolicy",
    label: "Leave",
    field: "leave_policy_id",
    relatedListKey: "leave_policies",
    responseKey: "leave_policys",
    previewKey: "leave_policy",
    createComponent: CreateLeavePolicy,
    updateComponent: UpdateLeavePolicy,
    requestFn: getLeavePolicyDataReq,
  },
  {
    key: "overtimePolicy",
    label: "Overtime",
    field: "overtime_policy_id",
    relatedListKey: "overtime_policies",
    responseKey: "overtime_policys",
    previewKey: "overtime_policy",
    createComponent: CreateOvertimePolicy,
    updateComponent: UpdateOvertimePolicy,
    requestFn: getOvertimePolicyDataReq,
  },
  {
    key: "cplPolicy",
    label: "CPL",
    field: "cpl_policy_id",
    relatedListKey: "cpl_policies",
    responseKey: "cpl_policys",
    previewKey: "cpl_policy",
    createComponent: CreateCplPolicy,
    updateComponent: UpdateCplPolicy,
    requestFn: getCplPolicyDataReq,
  },
];

export const attendancePlannerDependencyMap = attendancePlannerPolicyDependencies.reduce((acc, dependency) => {
  acc[dependency.key] = dependency;
  return acc;
}, {});

export const attendancePlannerPreviewKeyMap = attendancePlannerPolicyDependencies.reduce((acc, dependency) => {
  acc[dependency.previewKey] = dependency;
  return acc;
}, {});
